import * as React from 'react'
import { useState } from 'react'
import AdvancedLink from '../AdvancedLink'
import './index.less'
import {URL_YUQUE_FEATURES} from "../../constants/CyHomepage";

const clsPrefix = 'layout-header'

const links: {
  link: string,
  title: string | React.ReactNode,
  needLogin?: boolean,
  outerLink?: true;
  isOpenNewWindow?: boolean;
  isNew?: boolean
}[] = [
  {
    link: '/',
    title: '首页',
    outerLink: true,
    isOpenNewWindow: false
  },
  {
    link: '/practice',
    title: '体验',
    outerLink: true,
    isOpenNewWindow: false
  },
  {
    link: URL_YUQUE_FEATURES,
    title: '功能介绍',
    outerLink: true,
    isOpenNewWindow: true
  },
  {
    link: '/static/help/',
    title: '帮助文档',
    outerLink: true,
    isOpenNewWindow: true
  },
  {
    link: '/partner',
    title: '合作伙伴',
    outerLink: true,
    isOpenNewWindow: true
  },
  {
    link: 'https://m.kuaizhan.com/clubpc/forums/VIk9iSUgWjLKn1do#!/topics/tags/WBgw4K6mfilDzBdu/pages/0',
    title: '站长社区',
    outerLink: true,
    isOpenNewWindow: true
  },
]

const CyanLinksNav: React.FC<{
  navLinks?: Array<{
    link: string,
    title: string,
    outerLink?: boolean;
    isOpenNewWindow?: boolean;
    isNew?: boolean;
    category: string;
    page: string;
  }>,
  currentLink?: string,
  className?: string
}> = ({
  navLinks = links,
  currentLink = '',
  className = ''
}) => {

  function clickStat(category, page) {
    // 统计导航内容点击流量
    if (window) {
      // 用 stat-portrait
      // @ts-ignore
      window.xqui.useStat({
        action: 'click',
        category: category,
        bizType: 5,
        page: page
      })
    }
  }

  return (
    <div className={`${clsPrefix}__links-nav ${className}`}>
      {
        // @ts-ignore
        (navLinks && navLinks.length) ? navLinks.map(item => {
          const [isHovered, setIsHovered] = useState(false)
          return (
            <div
              key={item.link}
              className={`link ${item.isNew ? 'link-new' : ''}`}
              onMouseOver={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={() => clickStat(item.category, item.page)}
            >
                <AdvancedLink
                  href={item.link}
                  linkType={item.outerLink ? 'outer' : 'inner'}
                  isOpenNewWindow={item.isOpenNewWindow || false}
                  className={(currentLink === item.link) ? 'current-layout' : ''}
                >
                  {item.title}
                </AdvancedLink>
                <div className={(currentLink === item.link || isHovered) ? 'selected' : 'unselected'} />
              </div>
          )
        }) : ''
      }
    </div>
  )
}

export default CyanLinksNav
